export class AddToHomeScreen {
  constructor() {
    console.log('add to home screen!')
    this.deferredPrompt = null;
    this.setupEventListeners();
  }

  setupEventListeners() {
    // For iOS
    if (this.isIOS() && !this.isInStandaloneMode()) {
      this.showIOSPrompt();
    }
  }

  isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  isInStandaloneMode() {
    return window.matchMedia('(display-mode: standalone)').matches ||
           window.navigator.standalone;
  }

  showIOSPrompt() {
    const prompt = document.createElement('div');
    prompt.className = 'ios-prompt';
    prompt.innerHTML = `
      <button class="close-button" onclick="this.parentElement.remove()">×</button>
      <p>Add this app to your Home Screen!</p>
      <div class="instructions">
        <span>Tap</span>
        <span class="share-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4V15M12 4L8 8M12 4L16 8M8 12H6C4.89543 12 4 12.8954 4 14V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V14C20 12.8954 19.1046 12 18 12H16"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </span>
        <span>then "Add to Home Screen"</span>
      </div>
    `;
    document.body.appendChild(prompt);
  }
}
